import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
export default function BelowLogoScrollingText() {
    return (
        <div className="marquee-wrapper">
            <div class="marqueebelowlogo">
                <div class="marquee-track">
                    <span>We are the manufacturer/ Wholesaler / dealer / distburter / Retailer of All kinds of Casual wear We deal all top clothing brands</span>
                    <span>We are the manufacturer/ Wholesaler / dealer / distburter / Retailer of All kinds of Casual wear We deal all top clothing brands</span>
                </div>
            </div>
        </div>
    );
}